// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  worldId: __t.u64().primaryKey().name("world_id"),
  hasSpawn: __t.bool().name("has_spawn"),
  spawnX: __t.f32().name("spawn_x"),
  spawnY: __t.f32().name("spawn_y"),
  spawnZ: __t.f32().name("spawn_z"),
  spawnYaw: __t.f32().name("spawn_yaw"),
  objective: __t.string(),
  roundSeconds: __t.u32().name("round_seconds"),
  respawnMode: __t.string().name("respawn_mode"),
  scoreTopic: __t.string().name("score_topic"),
  updatedBy: __t.identity().name("updated_by"),
  updatedAt: __t.timestamp().name("updated_at"),
});
